import { deleteInvitation } from '@/store/module/member/mutation/deleteInvitation.js';
import { setInvitations } from '@/store/module/member/mutation/setInvitations.js';

export const mutations = {
	deleteInvitation,
	setInvitations
};
